"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import Reveal from "@/components/common/Reveal";
import { useLanguage } from "@/hooks/useLanguage";
import { type Lang } from "@/lib/i18n";
interface InquiryCopy {
  eyebrow: string;
  heading: string;
  supporting: string;
  cta: string;
  secondaryCta: string;
}
const content: Record<Lang, InquiryCopy> = {
  en: {
    eyebrow: "B2B INDUSTRIAL FILTRATION",
    heading: "Looking for a Specific Filtration Specification?",
    supporting: "Send us your required material, mesh count, aperture dimensions or engineering drawings for prompt review.",
    cta: "Request a Quote",
    secondaryCta: "Contact Our Team"
  },
  zh: {
    eyebrow: "B2B 工业过滤丝网",
    heading: "寻找特定的过滤与筛分产品规格？",
    supporting: "请向我们发送您所需的材质牌号、目数孔径、外形尺寸或工程图纸，我们将协助审核并匹配合适的产品方案。",
    cta: "索取技术报价",
    secondaryCta: "联系我们"
  },
  es: {
    eyebrow: "FILTRACIÓN INDUSTRIAL B2B",
    heading: "¿Busca una especificación de filtración concreta?",
    supporting: "Envíenos el material requerido, la malla, dimensiones o plano técnico para una revisión detallada.",
    cta: "Solicitar presupuesto",
    secondaryCta: "Contacte con nosotros"
  },
  de: {
    eyebrow: "B2B-INDUSTRIEFILTRATION",
    heading: "Suchen Sie eine bestimmte Filtrationsspezifikation?",
    supporting: "Senden Sie uns Ihren Werkstoff, Maschenweite, Abmessungen oder eine technische Zeichnung zur Prüfung.",
    cta: "Angebot anfragen",
    secondaryCta: "Kontakt aufnehmen"
  },
  fr: {
    eyebrow: "FILTRATION INDUSTRIELLE B2B",
    heading: "Vous recherchez une spécification de filtration précise ?",
    supporting: "Transmettez-nous le matériau souhaité, le maillage, les dimensions ou vos plans pour étude.",
    cta: "Demander un devis",
    secondaryCta: "Nous contacter"
  },
  pt: {
    eyebrow: "FILTRAÇÃO INDUSTRIAL B2B",
    heading: "Procura uma especificação de filtração específica?",
    supporting: "Envie-nos o material necessário, malha, dimensões ou desenho técnico para análise técnica.",
    cta: "Solicitar orçamento",
    secondaryCta: "Fale conosco"
  }
};
export default function Inquiry() {
  const {
    lang
  } = useLanguage();
  const copy = content[lang] || content.en;
  return <Reveal>
      <CtaBand id="productinquirycta" eyebrow={copy.eyebrow} heading={copy.heading} lead={copy.supporting} primary={{
      label: copy.cta,
      to: "/RequestAQuotePage"
    }} secondary={{
      label: copy.secondaryCta,
      to: "/ContactPage"
    }} />
    </Reveal>;
}